export const TRANSACTION_NOW_MESSAGE = 'As carteiras realizam movimentações até 15:30. Após esse horário, a movimentação será feita no próximo dia útil às 10:30.';

export default null;
